import React from "react";
import ReactDOM from "react-dom";

const App = () => <h1>Hello, this is Ishaan. Welcome to my Web App, Flamingo. Hope you are well and wishing you all the best.  - Ish the Fish</h1>;

ReactDOM.render(<App />, document.getElementById("root"));
